import React, {useState} from 'react';
import FactureUpdateView from './FactureUpdateView';
import {updateFacture, addFacture} from '../../../../services/MadricService';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function FactureUpdate(props) {
  const [inputValue, setInputValue] = useState(props.isUpdate ? props.selectedFacture.name : '');
  const [errors, setErrors] = useState('');

  /**
   * Permet de submit le form
   */
  async function handleSubmit() {
    let error = false;

    if (inputValue === '') {
      setErrors('Le nom de la facture est obligatoire');
      error = true;
    }

    if (!error) {
      setErrors('');
      props.setIsLoading(true);
      const res = props.isUpdate ? await updateFacture(props.selectedFacture.id, inputValue) : await addFacture(inputValue);
      props.setIsLoading(false);
      props.setFactures(res);
      setInputValue('');
      props.closeModal();
    }
  };

  return (
    <div>
      <FactureUpdateView
        closeModal={props.closeModal}
        isUpdate={props.isUpdate}
        setInputValue={setInputValue}
        inputValue={inputValue}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}

export default FactureUpdate;
